import React from "react";
import { useHistory } from "react-router";
import "./BackButton.css";
import Icon from "./Icon";

type BackButtonProp = {
    onBackClick?: () => void;
};

function BackButton({ onBackClick }: BackButtonProp) {
    const history = useHistory();

    const navigateBack = () => {
        history.goBack();
    };

    return (
        <span onClick={onBackClick ?? navigateBack} className="component-back-button">
            <Icon.ArrowBack.Medium />
        </span>
    );
}

export default BackButton;
